/* @flow */

import Localizer from '../../../../helpers/localization';
import { CustomNetworkError } from '../../../../libs/netgemLibrary/helpers/CustomNetworkError';
import { BO_PURCHASE_UNKNOWN_ERROR, mapV2ErrorToV1Error } from '../../../../libs/netgemLibrary/videofutur/types/ErrorCodes';
import { type BO_API_ERROR_TYPE } from '../videofutur/types/common';

const buildErrorResponse: (defaultStatus: ?string, data: any) => BO_API_ERROR_TYPE = (defaultStatus, data) => {
  if (data instanceof CustomNetworkError) {
    const status = mapV2ErrorToV1Error(data);
    if (status !== null) {
      return {
        errorMsg: '',
        status,
      };
    }
  }

  const { errormsg, message, status } = data;

  let errorMsg1: ?string = null;
  let errorMsg2: ?string = null;
  let errorStatus: ?string = null;

  if (errormsg) {
    if (typeof errormsg === 'string') {
      errorMsg2 = errormsg;
    } else {
      ({ _text: errorMsg2 } = errormsg);
    }
  }

  if (status) {
    if (typeof status === 'string') {
      errorStatus = status;
    } else {
      ({ _text: errorStatus } = status);
    }
  }

  if (message) {
    try {
      const messageObj = JSON.parse(message);
      if (messageObj) {
        const { result, status: errStatus } = messageObj;
        if (result && result.message) {
          errorMsg1 = result.message;
        }
        if (errStatus) {
          errorStatus = errStatus;
        }
      }
    } catch {
      errorMsg1 = message;
    }
  }

  return {
    errorMsg: errorMsg1 || errorMsg2 || Localizer.localize('common.messages.errors.unknown_bo_error'),
    status: defaultStatus || errorStatus || BO_PURCHASE_UNKNOWN_ERROR,
  };
};

export { buildErrorResponse };
